import classNames from 'classnames';
import { useState } from 'react';

import { Link } from '@components/Link';
import Typography from '@components/Typography';
import { Item, NearByAreasWrapper } from './styles';

import type { GetInfoByAreaTopCities } from '@graphql';
import type React from 'react';

type Props = {
  data: GetInfoByAreaTopCities[];
};

export const NearByAreas: React.FC<Props> = ({ data }) => {
  const [expandList, setExpandList] = useState(false);

  if (!data.length) {
    return null;
  }

  const onClickMore = (): void => {
    setExpandList(!expandList);
  };

  return (
    <NearByAreasWrapper>
      <Typography className="header" type="H3">
        Weitere Städte in Deutschland
      </Typography>

      <div className="items">
        {data.map((area, index) => (
          <Item key={area.url} className={classNames({ hidden: index > 10 && !expandList })}>
            <Link route={area.url}>{area.cityName || area.stateName}</Link>
          </Item>
        ))}
      </div>

      {data.length > 10 && (
        <Typography type="C1" as="button" className="more-button" onClick={onClickMore}>
          {!expandList ? 'Mehr' : 'Weniger'}
        </Typography>
      )}
    </NearByAreasWrapper>
  );
};
